import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import logitics from './routers/logistics' //智能物流
Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
        /*redirect:'linglongSurvey',*/
        children:[
            ...logitics,
        ]
    }

  ]
})
